import { render, staticRenderFns } from "./await-casetype.vue?vue&type=template&id=56793273&scoped=true"
import script from "./await-casetype.vue?vue&type=script&lang=ts"
export * from "./await-casetype.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56793273",
  null
  
)

export default component.exports